import styled from 'styled-components';

import { Select } from '@dreryk/react-components';

export const ConfidentialDataAccessSelect = styled(Select)`
   width: 145px;
` as typeof Select;
